(() => {
  const SELECTORS = {
    emissions: '.js-emissions-ack',
    terms: 'input[name="agree_terms"]',
    checkoutButtons: 'button[name="checkout"], input[name="checkout"]',
    accelContainers: '.additional-checkout-buttons'
  };

  function isChecked(el) {
    return !!(el && el.checked);
  }

  function refresh(root = document) {
    const emissions = root.querySelector(SELECTORS.emissions);
    const terms = root.querySelector(SELECTORS.terms);

    const needsEmissions = !!emissions;
    const needsTerms = !!terms;

    const ok = (!needsEmissions || isChecked(emissions)) && (!needsTerms || isChecked(terms));

    root.querySelectorAll(SELECTORS.checkoutButtons).forEach((btn) => {
      // Only touch buttons we can actually disable
      try {
        btn.disabled = !ok;
        btn.setAttribute('aria-disabled', String(!ok));
      } catch (e) {}
    });

    // Hide accelerated checkout buttons if gating is not satisfied
    root.querySelectorAll(SELECTORS.accelContainers).forEach((el) => {
      el.style.display = ok ? '' : 'none';
    });

    // Show hint under emissions checkbox if needed
    const hint = root.querySelector('.js-emissions-ack-hint');
    if (hint && needsEmissions) {
      hint.style.display = isChecked(emissions) ? 'none' : 'block';
    }
  }

  function onChange(e) {
    const t = e.target;
    if (!t) return;
    if (t.matches(SELECTORS.emissions) || t.matches(SELECTORS.terms)) {
      refresh(document);
    }
  }

  document.addEventListener('change', onChange, true);

  const run = () => refresh(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Watch for cart drawer/ajax re-renders
  const obs = new MutationObserver(() => refresh(document));
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
